/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../common/glyph/glyph_icon';
import '../../common/printable_check/printable_check_log_events';
import '../../common/printable_check/printable_check_education';
import '../../common/component/component';
import '../../common/printable_check/printable_check';
import '../../common/printable_check/printable_check_input';
import '../../common/printable_check/printable_check_responses';
import '../../common/printable_check/printable_check_requests';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckAccessResponse": {
                    "fields": {
                      "allow": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse.Allow",
                        "id": 1
                      },
                      "forbid": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse.Forbid",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Allow": {
                        "fields": {
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "logEvents": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Entry",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Forbid": {
                        "fields": {}
                      },
                      "access": {
                        "oneof": ["allow", "forbid"]
                      }
                    }
                  },
                  "CreatePrintableCheckConfiguration": {
                    "fields": {
                      "educationConfiguration": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration.EducationConfiguration",
                        "id": 1,
                        "rule": "optional"
                      },
                      "writeCheckConfiguration": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration.WriteCheckConfiguration",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "EducationConfiguration": {
                        "fields": {
                          "headerTitle": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "education": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckEducation",
                            "id": 2,
                            "rule": "optional"
                          },
                          "continueButton": {
                            "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                            "id": 3,
                            "rule": "optional"
                          },
                          "doNotShowAgainButton": {
                            "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                            "id": 4,
                            "rule": "optional"
                          },
                          "logEvents": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Education",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "WriteCheckConfiguration": {
                        "fields": {
                          "headerTitle": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "preview": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckPreview",
                            "id": 2,
                            "rule": "optional"
                          },
                          "checkPreviewDisclaimer": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "amountInput": {
                            "type": ".squareup.bbfrontend.common.component.MoneyInputDescription",
                            "id": 4,
                            "rule": "optional"
                          },
                          "recipientInput": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckTextInput",
                            "id": 5,
                            "rule": "optional"
                          },
                          "memoInput": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckTextInput",
                            "id": 6,
                            "rule": "optional"
                          },
                          "continueButton": {
                            "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                            "id": 7,
                            "rule": "optional"
                          },
                          "logEvents": {
                            "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Write",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "BootstrapCreatePrintableCheckResponse": {
                    "fields": {
                      "balanceIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "createCheckConfiguration": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreatePrintableCheckResponse": {
                    "fields": {
                      "success": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckSuccess",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckError",
                        "id": 2
                      },
                      "unrecoverableError": {
                        "type": ".squareup.bbfrontend.common.printable_check.CreatePrintableCheckUnrecoverableError",
                        "id": 3
                      }
                    },
                    "nested": {
                      "CreatePrintableCheckSuccess": {
                        "fields": {
                          "printableCheckId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "configuration": {
                            "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckSuccess.CheckIssuedConfiguration",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CheckIssuedConfiguration": {
                            "fields": {
                              "icon": {
                                "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                                "id": 1,
                                "rule": "optional"
                              },
                              "titleText": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "subtitleText": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "printCheckButton": {
                                "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                                "id": 4,
                                "rule": "optional"
                              },
                              "downloadCheckButton": {
                                "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                                "id": 5,
                                "rule": "optional"
                              },
                              "logEvents": {
                                "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Success",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "CreatePrintableCheckError": {
                        "fields": {
                          "configuration": {
                            "type": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration.WriteCheckConfiguration",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "error", "unrecoverableError"]
                      }
                    }
                  },
                  "DashboardWebPrintableCheckService": {
                    "methods": {
                      "GetPrintableCheckAccess": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.PrintableCheckAccessRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse"
                      },
                      "BootstrapCreatePrintableCheck": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.BootstrapCreatePrintableCheckRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.printable_check.BootstrapCreatePrintableCheckResponse"
                      },
                      "CreatePrintableCheck": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.CreatePrintableCheckRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse"
                      },
                      "DownloadPrintableCheck": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.DownloadPrintableCheckRequest",
                        "responseType": ".squareup.bbfrontend.common.printable_check.DownloadPrintableCheckResponse"
                      },
                      "CancelPrintableCheck": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.CancelPrintableCheckRequest",
                        "responseType": ".squareup.bbfrontend.common.printable_check.CancelPrintableCheckResponse"
                      },
                      "BootstrapPrintableCheckManagement": {
                        "requestType": ".squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementRequest",
                        "responseType": ".squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.PrintableCheckAccessResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.PrintableCheckAccessResponse?.nested?.Allow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.PrintableCheckAccessResponse?.nested?.Forbid && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckConfiguration?.nested?.EducationConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckConfiguration?.nested?.WriteCheckConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.BootstrapCreatePrintableCheckResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckResponse?.nested?.CreatePrintableCheckSuccess && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckResponse?.nested?.CreatePrintableCheckSuccess?.nested?.CheckIssuedConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.CreatePrintableCheckResponse?.nested?.CreatePrintableCheckError && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.printable_check?.nested?.DashboardWebPrintableCheckService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckAccessResponse @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 21:1
 */
export const PrintableCheckAccessResponse = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse');
fixType(PrintableCheckAccessResponse);
Builder.createAndAttachToType(PrintableCheckAccessResponse);
/**
 * SOURCE Allow @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 27:3
 */
PrintableCheckAccessResponse.Allow = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse.Allow');
fixType(PrintableCheckAccessResponse.Allow, {
  icon: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PrintableCheckAccessResponse.Allow);
/**
 * SOURCE Forbid @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 35:3
 */
PrintableCheckAccessResponse.Forbid = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.PrintableCheckAccessResponse.Forbid');
fixType(PrintableCheckAccessResponse.Forbid);
Builder.createAndAttachToType(PrintableCheckAccessResponse.Forbid);
/**
 * SOURCE CreatePrintableCheckConfiguration @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 38:1
 */
export const CreatePrintableCheckConfiguration = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration');
fixType(CreatePrintableCheckConfiguration, {
  educationConfiguration: {
    required: true
  },
  writeCheckConfiguration: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckConfiguration);
/**
 * SOURCE EducationConfiguration @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 42:3
 */
CreatePrintableCheckConfiguration.EducationConfiguration = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration.EducationConfiguration');
fixType(CreatePrintableCheckConfiguration.EducationConfiguration, {
  headerTitle: {
    notEmpty: true
  },
  education: {
    required: true
  },
  continueButton: {
    required: true
  },
  doNotShowAgainButton: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckConfiguration.EducationConfiguration);
/**
 * SOURCE WriteCheckConfiguration @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 50:3
 */
CreatePrintableCheckConfiguration.WriteCheckConfiguration = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckConfiguration.WriteCheckConfiguration');
fixType(CreatePrintableCheckConfiguration.WriteCheckConfiguration, {
  headerTitle: {
    notEmpty: true
  },
  preview: {
    required: true
  },
  checkPreviewDisclaimer: {
    notEmpty: true
  },
  amountInput: {
    required: true
  },
  recipientInput: {
    required: true
  },
  memoInput: {
    required: true
  },
  continueButton: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckConfiguration.WriteCheckConfiguration);
/**
 * SOURCE BootstrapCreatePrintableCheckResponse @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 62:1
 */
export const BootstrapCreatePrintableCheckResponse = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.BootstrapCreatePrintableCheckResponse');
fixType(BootstrapCreatePrintableCheckResponse, {
  balanceIds: {
    required: true
  },
  createCheckConfiguration: {
    required: true
  }
});
Builder.createAndAttachToType(BootstrapCreatePrintableCheckResponse);
/**
 * SOURCE CreatePrintableCheckResponse @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 67:1
 */
export const CreatePrintableCheckResponse = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse');
fixType(CreatePrintableCheckResponse);
Builder.createAndAttachToType(CreatePrintableCheckResponse);
/**
 * SOURCE CreatePrintableCheckSuccess @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 74:3
 */
CreatePrintableCheckResponse.CreatePrintableCheckSuccess = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckSuccess');
fixType(CreatePrintableCheckResponse.CreatePrintableCheckSuccess, {
  printableCheckId: {
    required: true
  },
  configuration: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckResponse.CreatePrintableCheckSuccess);
/**
 * SOURCE CheckIssuedConfiguration @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 78:5
 */
CreatePrintableCheckResponse.CreatePrintableCheckSuccess.CheckIssuedConfiguration = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckSuccess.CheckIssuedConfiguration');
fixType(CreatePrintableCheckResponse.CreatePrintableCheckSuccess.CheckIssuedConfiguration, {
  icon: {
    required: true
  },
  titleText: {
    notEmpty: true
  },
  subtitleText: {
    notEmpty: true
  },
  printCheckButton: {
    required: true
  },
  downloadCheckButton: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckResponse.CreatePrintableCheckSuccess.CheckIssuedConfiguration);
/**
 * SOURCE CreatePrintableCheckError @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 88:3
 */
CreatePrintableCheckResponse.CreatePrintableCheckError = $root.lookupType('squareup.bbfrontend.dashboard.printable_check.CreatePrintableCheckResponse.CreatePrintableCheckError');
fixType(CreatePrintableCheckResponse.CreatePrintableCheckError, {
  configuration: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckResponse.CreatePrintableCheckError);
/**
 * SOURCE DashboardWebPrintableCheckService @ squareup/bbfrontend/dashboardweb/printable_check/printable_check_service.proto at 97:1
 */
export const DashboardWebPrintableCheckService = $root.lookupService('squareup.bbfrontend.dashboard.printable_check.DashboardWebPrintableCheckService');